import { twMerge } from "tailwind-merge";
import type { SxProps, Theme } from "@mui/material/styles";

import { Typography } from "ui/typography";

type FormBuilderFieldDisplayProps = {
  label: string;
  value: string;
  /** When set, renders the value as a clickable link instead of plain text. */
  href?: string;
  className?: string;
};

/** `body2` carries the 14px/400 metrics; the 20px line height has no theme slot (`body2` is 1.4). */
const LABEL_SX: SxProps<Theme> = (theme) => ({
  lineHeight: "1.25rem",
  color: theme.palette.grey[500],
});

const FormBuilderFieldDisplay = ({ label, value, href, className }: FormBuilderFieldDisplayProps) => {
  const valueClassName = twMerge(
    "whitespace-pre-wrap text-base font-medium leading-6",
    href ? "text-aqua-600 underline" : "text-gray-900",
  );
  const valueNode = href ? (
    <a href={href} target="_blank" rel="noreferrer" className={valueClassName}>
      {value}
    </a>
  ) : (
    <span className={valueClassName}>{value}</span>
  );

  if (!label.trim()) {
    return href ? (
      <a href={href} target="_blank" rel="noreferrer" className={twMerge(valueClassName, className)}>
        {value}
      </a>
    ) : (
      <span className={twMerge(valueClassName, className)}>{value}</span>
    );
  }

  return (
    <div className={twMerge("flex flex-col gap-1", className)}>
      <Typography component="span" variant="body2" sx={LABEL_SX}>
        {label}
      </Typography>
      {valueNode}
    </div>
  );
};

export default FormBuilderFieldDisplay;
